import axiosInstance from '../axios';
import { useMutation, useQuery } from '@tanstack/react-query';
import { clearPageCache, getPageCache, putPageCache } from '../../utils/cache';
import { NotificationPayload, NotificationQueryResponse, NotificationResponse } from '../../type/Notification';

const listNotifications = async (payload: any): Promise<any> => {
	if (getPageCache('notification', payload)) {
		return getPageCache('notification', payload);
	}
	const response: any = await axiosInstance.post<any>(
		'/notification/getNotificationByUser',
		payload,
	);
	putPageCache('notification', payload, response.data.data);
	return response.data.data;
};

export const useListNotifications = (payload: any) => {
	return useQuery<any, Error>({
		queryKey: ['listNotifications', payload],
		queryFn: () => listNotifications(payload),
	});
};

// Create Payment Type API
const createNotification = async (payload: any): Promise<any> => {
	const response: any = await axiosInstance.post<any>(
		'/notification/createNotification',
		payload,
	);
	clearPageCache('notification');
	return response.data;
};

export const useCreatePaymentType = () => {
	return {
		mutateAsync: (payload: any) => createNotification(payload),
	};
};

// Activate Payment Type by ID
export const useReadNotifications = () => {
	clearPageCache('notification');
	return {
		mutate: (payload: any, options?: any) =>
			axiosInstance
				.post('/notification/readNotifications', payload)
				.then((res) => options?.onSuccess?.(res.data))
				.catch(options?.onError),
	};
};

// Update Payment Type by ID
const updateNotificationById = async (payload: any): Promise<any> => {
	clearPageCache('notification');
	const response: any = await axiosInstance.post<any>(
		'/notification/updateNotificationById',
		payload,
	);
	return response.data;
};

export const useUpdatePaymentTypeById = () => {
	return {
		mutateAsync: (payload: any) => updateNotificationById(payload),
	};
};

// Search Payment Types
export const useSearchNotifications = () => {
	return {
		mutate: (payload: any, options?: any) =>
			axiosInstance
				.post('/pType/searchNotifications', payload)
				.then((res) => options?.onSuccess?.(res.data))
				.catch(options?.onError),
	};
};

// Get Payment Type by ID
const getNotificationById = async (payload: any): Promise<any> => {
	const response: any = await axiosInstance.post<any>(
		'/notification/getNotificationById',
		payload,
	);
	return response.data;
};

export const useGetPaymentTypeById = () => {
	return useMutation<any, Error, any>({
		mutationKey: ['getNotificationById'],
		mutationFn: getNotificationById,
	});
};


// List NOC
const listNotification = async (
	payload: NotificationPayload,
): Promise<NotificationResponse> => {
	if (getPageCache('noc_list', payload)) {
		return getPageCache('noc_list', payload);
	}
	const response: any = await axiosInstance.post<NotificationResponse>(
		'/notification/listNotifications',
		payload,
	);
	putPageCache('noc_list', payload, response.data.data);
	return response.data.data;
};

export const useListNotification = (payload: NotificationPayload) => {
	return useQuery<NotificationResponse, Error>({
		queryKey: ['listNotifications', payload],
		queryFn: () => listNotification(payload),
		enabled: !!payload, // Optional: disables query until payload is available
	});
};

const getNotificationQById = async (payload: NotificationPayload): Promise<NotificationQueryResponse> => {
	if (getPageCache('listStocks', payload)) {
		return getPageCache('listStocks', payload);
	}
	const response: any = await axiosInstance.post<NotificationQueryResponse>(
		'/notification/getNotificationById',
		payload,
	);
	putPageCache('listStocks', payload, response.data.data);
	return response.data.data;
};

export const useGetNotificationQById = (payload: NotificationPayload) => {
	return useQuery<NotificationQueryResponse, Error>({
		queryKey: ['getNotificationQById', payload],
		queryFn: () => getNotificationQById(payload),
		enabled: !!payload, // Optional: disables query until payload is available
	});
};
